<template>
	<div id="body">
		<div class="title">
			<i class="bi bi-person"></i> 会员中心
		</div>

		<div class="card">
			<div class="carditem">
				<div style="color: #FFF9EC; text-align: center;">完善信息</div>
				<span class="jdt">账号状态:&nbsp;<span style="font-size: 18px;">{{ status }}</span></span>
				<div>
					<el-progress :text-inside="true" :stroke-width="18" :percentage="percentage" :color="customColors">
					</el-progress>
				</div>
			</div>
		</div>

		<div id="item" style="width: 95%; margin: 0 auto;">
			<ul class="list-group">
				<li class="list-group-item d-flex justify-content-between align-items-center">
					<div>头像</div>
					<span id="image">
						<img :src="headimgUrl" style="width: 50px; height: 50px; border-radius: 50px;">
					</span>
					<i class="bi bi-vimeo" v-if="this.$route.query.status==4"
						style="display: flex; margin-left: -85%; color: #0000FF; margin-top: -14%; margin-right: -3%;">
					</i>
				</li>
				<li class="list-group-item d-flex justify-content-between align-items-center">
					<div>用户名</div>
					<span class="text">
						{{ realName }}
					</span>
				</li>
				<li class="list-group-item d-flex justify-content-between align-items-center">
					<div>身份证号码</div>
					<span class="text">
						{{idNumber}}
					</span>
				</li>
				<li class="list-group-item d-flex justify-content-between align-items-center">
					<div>手机号码</div>
					<span class="text">{{phone}}</span>
				</li>

				<a :href="this.href">
					<li class="list-group-item d-flex justify-content-between align-items-center">
						<div>当前状态</div>
						<span class="text" style="color: #005CBF;">{{ text }}</span>
					</li>
				</a>
				<li class="list-group-item d-flex justify-content-between align-items-center"
					v-if="this.$route.query.status==4 && this.type==0" style="margin-top: 3%;">
					<div>公司名称</div>
					<span class="text">
						{{ cmpName }}
					</span>
				</li>
				<li class="list-group-item d-flex justify-content-between align-items-center"
					v-if="this.$route.query.status==4">
					<div>会员等级</div>
					<span class="text">
						{{ member }}
					</span>
				</li>

				<a href="wallet" v-if="this.$route.query.status==4" style="margin-top: 3%;">
					<li class="list-group-item d-flex justify-content-between align-items-center">
						<div>我的钱包</div>
						<span class="text"><i class="bi bi-chevron-right"></i></span>
					</li>
				</a>
				<a href="order" v-if="this.$route.query.status==4">
					<li class="list-group-item d-flex justify-content-between align-items-center">
						<div>历史订单</div>
						<span class="text"><i class="bi bi-chevron-right"></i></span>
					</li>
				</a>
        <a href="uploadId" v-if="this.$route.query.status==4">
          <li class="list-group-item d-flex justify-content-between align-items-center">
            <div>实名信息</div>
            <span class="text"><i class="bi bi-chevron-right"></i></span>
          </li>
        </a>
				<a href="forget" v-if="this.$route.query.status>1">
					<li class="list-group-item d-flex justify-content-between align-items-center">
						<div>设置密码</div>
						<span class="text"><i class="bi bi-chevron-right"></i></span>
					</li>
				</a>
				
				<li class="list-group-item d-flex justify-content-between align-items-center" 
					v-if="this.$route.query.status>=1"
					@click="cancellation">
					<div>注销账号</div>
					<span class="text"><i class="bi bi-chevron-right"></i></span>
				</li>
				
				<el-dialog title="请输入密码" :visible.sync="searchPass" width="90%" :before-close="handleClose">
					<el-input placeholder="请输入六位数字密码" type="tel" 
					style="-webkit-text-security: square" maxlength="6" minlength="6"
					onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
					v-model="pass"></el-input>
					<div style="margin-top: 4%; color: red;">
						<i class="el-icon-warning-outline"></i>
						<span style="color: red;">注销后该账号的所有信息将会清空</span>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="searchPass = false" style="width: 30%;" type="warning">取 消</el-button>
						<el-button type="danger" style="width: 30%;" @click="cancelByOpenId">确定注销</el-button>
					</span>
				</el-dialog>

        <el-dialog title="注销账号" :visible.sync="searchPass1" width="90%" :before-close="handleClose">
          <div style="margin-top: 4%; color: red;">
            <i class="el-icon-warning-outline"></i>
            <span style="color: red;">注销后该账号的所有信息将会清空</span>
          </div>
          <span slot="footer" class="dialog-footer">
						<el-button @click="searchPass = false" style="width: 30%;" type="warning">取 消</el-button>
						<el-button type="danger" style="width: 30%;" @click="cancelByOpenId">确定注销</el-button>
					</span>
        </el-dialog>

			</ul>
		</div>
	</div>
</template>


<script>
	import {
		getCookie,
		setCookie
	} from '../api'
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: "info",
		data() {
			return {
				searchPass:false,
        searchPass1:false,
				//进度条
				percentage: 0,
				status: '',
				openId: '',
				customColor: '#409eff',
				customColors: [{
						color: '#f56c6c',
						percentage: 20
					},
					{
						color: '#e6a23c',
						percentage: 40
					},
					{
						color: '#5cb87a',
						percentage: 60
					},
					{
						color: '#1989fa',
						percentage: 80
					},
					{
						color: '#6f7ad3',
						percentage: 100
					}
				],

				show: true,
				show1: true,
				realName: '',
				headimgUrl: '',
				idNumber: '',
				phone: '',
				userId: '',
				cmpName: '',
				member: '',
				pass:'',
				type: '',
				text: '',
				href: '',
        password:'',
        isFreeze:'',
			};
		},
		methods: {
			...mapMutations(['changeStatus', 'changeLoginUserId', 'changeOpenId']),
      cancellation(){
			  if(this.password != null && this.password!=''){
          this.searchPass=true
        }else{
          this.searchPass1=true
        }

      },
			cancelByOpenId(){
        if(this.password != null && this.password!=''){
          if(this.pass.length==6){
            this.$api({
              methods: 'get',
              url: '/mobileLogin/cancelByOpenId',
              params: {
                openId: this.openId,
                password: this.pass
              }
            }).then(res=>{
              if(res.data.code == 200){
                this.$router.go(0)
                this.$router.push('/success?text='+res.data.msg)
              }else{
                this.$notify.info({
                  title: res.data.msg,
                  showClose: false,
                  duration: 5000
                });
              }
            })
          }else{
            this.$notify.info({
              title: '请输入六位数字密码',
              showClose: false,
              duration: 5000
            });
          }
        }else{
          this.$api({
            methods: 'get',
            url: '/mobileLogin/cancelByOpenId',
            params: {
              openId: this.openId,
              password: this.pass
            }
          }).then(res=>{
            if(res.data.code == 200){
              this.$router.push('/success?text='+res.data.msg)
            }else{
              this.$notify.info({
                title: res.data.msg,
                showClose: false,
                duration: 5000
              });
            }
          })
        }

			},
			getInfoByOpenId() {
			  console.log("getInfoByOpenId")
				this.$api({
					methods: 'get',
					url: '/mobileLogin/getInfoByOpenId?openId=' + this.openId,
				}).then((res) => {
					this.status = res.data.status
					this.realName = res.data.realName
					this.headimgUrl = res.data.headimgUrl
					this.idNumber = res.data.idNumber
					this.phone = res.data.phone
					this.userId = res.data.userId
					this.cmpName = res.data.companyName
					this.member = res.data.member
					this.type = res.data.type
          this.password = res.data.password
          this.isFreeze = res.data.isFreeze

					this.$store.state.realName = res.data.realName

					this.changeStatus({
						status: this.status
					})
					this.changeLoginUserId({
						userId: this.userId
					})
					this.changeOpenId({
						openId: this.openId
					})

					if (this.member == 0) {
						this.member = '普通会员'
					} else if (this.member == 1) {
						this.member = '银卡会员'
					} else if (this.member == 2) {
						this.member = '金牌会员'
					} else if (this.member == 3) {
						this.member = '白金会员'
					} else if (this.member == 4) {
						this.member = '包月会员'
					}


					if (this.status == 1) {
						this.status = '待审批'
						this.href = ''
						this.text = '正在审批'
						this.percentage = 40
					} else if (this.status == 0) {
						this.status = '已关注'
						this.href = 'registerHome'
						this.text = '去注册 >'
						this.percentage = 20
					} else if (this.status == 2) {
						this.status = '已审批,待认证'
						this.href = 'uploadId'
						this.text = '去实名 >'
						this.percentage = 60
					} else if (this.status == 3) {
						this.href = ''
						this.text = '等待认证'
						this.status = '正在认证'
						this.percentage = 80
					} else if (this.status == 4) {
						this.href = ''
						this.text = '该账号已认证'
						this.status = '已认证通过'
						this.percentage = 100
					}

				})
			}
		},
		created() {
		    console.log("info created")
        localStorage.setItem('openId',this.$route.query.openid)
        this.$store.state.openId = this.$route.query.openid
        this.openId = this.$route.query.openid
        let date = 6000 * 60 * 60
        //this.$Cookies.set('thirdsession', this.$route.query.thirdsession, date)
        localStorage.setItem("status", this.$route.query.status)
        localStorage.setItem("openId", this.$route.query.openid)
        localStorage.setItem("userId", this.$route.query.userId)
        this.status = this.$route.query.status
        if (this.status != 0 && this.status != 1 && this.status != 2 && this.status != 3 && this.status != 4) {
            this.$router.push('/error?text=该账号已被冻结')
        }
        this.getInfoByOpenId()

        if (this.isFreeze == 1) {
          this.$router.push('/error?text=该账号已被冻结')
        }
    }
	};
</script>

<style scoped>
	.name {
		width: 35%;
		border: none;
		float: right;
		text-align: center;
		color: #000000;
		background-color: #FFFFFF;
	}


	.text {
		color: #000000;
	}

	.card {
		width: 95%;
		margin: 0 auto;
		height: 6.25rem;
		background-color: #0062CC;
		border-radius: 0.3125rem;
		margin-top: 0.5125rem;
		margin-bottom: 0.3125rem;
	}

	.carditem {
		width: 95%;
		margin: 0 auto;
		height: 6.25rem;
		background-color: #0062CC;
		line-height: 1.9125rem;
	}

	.item {
		color: #FFFFFF;
	}

	.jdt {
		font-size: 0.7375rem;
		color: #FFFFFF;
		float: none;
	}

	#body {
		background-color: #f5f5f5;
		height: 100%;
	}

	#image {
		width: 3.25rem;
		height: 3.25rem;
		border-radius: 50%;
		/* background-image: url(./img/backgourp.jpg); */
	}

	#bot {
		margin-top: 1.5125rem;
	}

	button {
		margin-top: 1.55rem;
		width: 80%;
		margin-left: 10%;
	}

	a {
		text-decoration: none;
	}
</style>
